import React from 'react';
import PropTypes from 'prop-types';
import MuiSelect from '@material-ui/core/Select';
import MaterialFormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import classnames from 'classnames';
import isNil from 'lodash/isNil';

import styles from './styles.module.scss';

const SelectNative = React.forwardRef(
    (
        {
            className,
            helperText,
            placeholderValue,
            canSelectPlaceholder,
            options,
            children,
            value,
            ...rest
        },
        ref
    ) => {
        const selectClassNames = classnames(styles.root, className, {
            [styles.placeholder]:
                !isNil(value) &&
                !isNil(placeholderValue) &&
                value === placeholderValue
        });
        // if a placeholderValue prop exists AND the value prop is null or undefined
        // display the placeholder value
        let selectValue = value;
        if (isNil(selectValue) && placeholderValue) {
            selectValue = placeholderValue;
        }
        return (
            <MaterialFormControl fullWidth>
                <MuiSelect
                    native
                    fullWidth
                    variant="outlined"
                    className={selectClassNames}
                    value={selectValue}
                    ref={ref}
                    {...rest}
                >
                    {options.map(({ text, value: v }) => {
                        const valueIsPlaceholder = v === placeholderValue;
                        const placeholderDisabled =
                            valueIsPlaceholder && !canSelectPlaceholder;

                        return (
                            <option
                                name={text}
                                key={v}
                                value={v}
                                disabled={placeholderDisabled}
                            >
                                {text}
                            </option>
                        );
                    })}
                    {children}
                </MuiSelect>
                {helperText && (
                    <FormHelperText variant="outlined" error={rest.error}>
                        {helperText}
                    </FormHelperText>
                )}
            </MaterialFormControl>
        );
    }
);

SelectNative.propTypes = {
    ...MuiSelect.propTypes,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.any,
            value: PropTypes.any
        })
    ),
    placeholderValue: PropTypes.any,
    canSelectPlaceholder: PropTypes.bool,
    value: PropTypes.string
};

SelectNative.defaultProps = {
    ...MuiSelect.defaultProps,
    options: [],
    placeholderValue: null,
    canSelectPlaceholder: false,
    value: null
};

export default SelectNative;
